<template>
  <div class="layout layout--default layout--padd">
    <Header />
    <HeaderBanner />
    <div class="u-width-wrapper">
      <div class="main-content">
        <SideBlock region="content_above" />
        <div class="container">
          <div class="page-info card">
            <h1 v-if="error?.statusCode === 404">Page not found</h1>
            <h1 v-else-if="error?.statusCode === 500">Error</h1>
            <h1 v-else>An error occurred</h1>

            <p>
              We're sorry, but it would seem the item you requested had an
              error. Please try searching above or alternatively go back to our
              <NuxtLink to="/">Home page</NuxtLink>.
            </p>
          </div>
        </div>
        <SideBlock region="content_below" />
      </div>
      <Sidebar />
    </div>
    <Footer />
  </div>
</template>
<script setup lang="ts">
  const error = useError();
</script>
